export default __webpack_public_path__ + "static/media/dolls_00.8145eb5f.png";